<template>
  <div>
    <mdb-modal removeBackdrop size="xl" :show="modalShow" @close="handleClose" info>
      <mdb-modal-header color="indigo">
        <mdb-modal-title>{{ title }}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          {{ description }}
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <mdb-input active :customValidation="this.ValidActivated" :isValid="this.valid" icon="quote-right"
              :label="inputLabel" v-model="value" @change="inputCheck" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <mdb-input v-if="button1" v-model="box1checked" :label="button1" id="checkBox1" type="checkbox"
              class="form-check-input" />
          </mdb-col>
          <mdb-col>
            <mdb-input v-if="button2" v-model="box2checked" :label="button2" id="checkBox2" type="checkbox"
              class="form-check-input" />
          </mdb-col>
        </mdb-row>
        <mdb-datatable-2 v-if="dataShow" v-model="dataModal" />
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-col>
          <mdb-input v-if="checkboxShow" v-model="checkboxChecked" label="Tarkka haku" type="checkbox"
            class="form-check-input" id="defaultUnchecked" />
        </mdb-col>
        <mdb-btn @click="handleOk" color="indigo">{{ buttontext }}</mdb-btn>
        <mdb-btn v-if="buttonDeleteText != null && dataShow == true" @click="handleDelete" color="indigo">{{ buttonDeleteText }}</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
import {
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbInput,
  mdbBtn,
  mdbCol,
  mdbRow,
  mdbDatatable2,
} from "mdbvue";
export default {
  name: "InputModal",
  props: {
    modalShow: Boolean,
    dataShow: Boolean,
    checkboxShow: Boolean,
    title: String,
    description: String,
    inputLabel: String,
    buttontext: String,
    buttonDeleteText: String,
    dataModal: Object,
    button1: String,
    button2: String,
    characterMinLimit: {
      type: Number,
      default: 0,
    },
  },
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbInput,
    mdbBtn,
    mdbCol,
    mdbRow,
    mdbDatatable2,
  },
  data() {
    return {
      value: "",
      valid: false,
      checkboxChecked: false,
      ValidActivated: false,
      searchCheckBox: "",
      box1checked: false,
      box2checked: false,
    };
  },
  methods: {
    inputCheck() {
      this.valid = this.value.length > this.characterMinLimit;
    },

    handleOk() {
      if (this.valid) {
        this.$emit("modal-ok", this.value, this.checkboxChecked, this.searchCheckBox);
      } else {
        this.ValidActivated = true;
      }
    },
    handleDelete() {
      if (this.valid) {
        this.$emit("modal-delete", this.value);
      } else {
        this.ValidActivated = true;
      }
    },
    handleClose() {
      console.log("modal hide");
      this.ValidActivated = false;
      this.$emit("modal-cancelled");
    },
  },
  watch: {
    box1checked() {
      this.box2checked = !this.box1checked;
      this.searchCheckBox = 1;
    },
    box2checked() {
      this.box1checked = !this.box2checked;
      this.searchCheckBox = 2;
    }
  }
};
</script>
